(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-manufacturers"] && !Shopify.designMode) return;
  try {
    
class ManufacturerOverview extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('[data-manufacturers-body]');
    this.loading = this.querySelector('.main-manufacturers__loading');
    if (!this.body) return;

    // Delegated smooth-scroll so it survives a rebuild of the body.
    this.addEventListener('click', this.onNavClick.bind(this));

    this.hydrate();
  }

  get totalPages() {
    return parseInt(this.dataset.totalPages, 10) || 1;
  }

  async hydrate() {
    // Rows rendered server-side for the first paginated page.
    let rows = Array.from(this.querySelectorAll('.main-manufacturers__table-row'));

    try {
      if (this.totalPages > 1) {
        if (this.loading) this.loading.hidden = false;
        const fetched = await this.fetchRemainingRows();
        rows = rows.concat(fetched);
        if (this.loading) this.loading.hidden = true;

        // Only rebuild when there is something extra to merge; otherwise the
        // server render is already complete and correctly ordered enough.
        this.render(rows);
      }
    } finally {
      // Reveal in one piece. In `finally` so a failed fetch or a throw in
      // render() still shows the server-rendered subset rather than leaving
      // the section permanently blank.
      if (this.body) this.body.removeAttribute('data-pending');
      if (this.loading) this.loading.hidden = true;
    }
  }

  async fetchRemainingRows() {
    const sectionId = this.dataset.sectionId;
    const pageParam = this.dataset.paginateParam || 'page';
    const requests = [];
    for (let page = 2; page <= this.totalPages; page++) {
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&${encodeURIComponent(pageParam)}=${page}`;
      requests.push(
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('.main-manufacturers__table-row')).map((node) =>
              document.importNode(node, true)
            );
          })
          .catch(() => [])
      );
    }
    const pages = await Promise.all(requests);
    return pages.flat();
  }

  render(rows) {
    // Dedupe by manufacturer handle, then group by country.
    const seen = new Set();
    const groups = new Map(); // handle -> { name, rows: [] }

    for (const row of rows) {
      const handle = row.dataset.handle;
      if (handle && seen.has(handle)) continue;
      if (handle) seen.add(handle);

      const countryHandle = row.dataset.countryHandle;
      if (!countryHandle) continue;
      if (!groups.has(countryHandle)) {
        groups.set(countryHandle, { name: row.dataset.countryName || '', rows: [] });
      }
      groups.get(countryHandle).rows.push(row);
    }

    const collator = new Intl.Collator('nl', { sensitivity: 'base' });
    const sortedCountries = Array.from(groups.entries()).sort((a, b) =>
      collator.compare(a[1].name, b[1].name)
    );

    // Reuse the server-rendered <nav> and content wrappers so their layout
    // classes are preserved; only swap the inner items.
    const navList = this.querySelector('.main-manufacturers__nav-list');
    if (navList) {
      navList.replaceChildren(
        ...sortedCountries.map(([handle, group]) => this.buildNavItem(handle, group))
      );
    }

    const content = this.querySelector('.main-manufacturers__content');
    if (content) {
      content.replaceChildren(
        ...sortedCountries.map(([handle, group]) => {
          group.rows.sort((a, b) => collator.compare(a.dataset.name || '', b.dataset.name || ''));
          return this.buildCountrySection(handle, group);
        })
      );
    }
  }

  buildNavItem(handle, group) {
    const li = document.createElement('li');
    li.className = 'main-manufacturers__nav-item';
    const a = document.createElement('a');
    a.className = this.dataset.navLinkClass || 'main-manufacturers__nav-button';
    if (this.dataset.navLinkStyle) a.setAttribute('style', this.dataset.navLinkStyle);
    a.href = `#country-${handle}`;
    a.textContent = group.name;
    li.appendChild(a);
    return li;
  }

  buildCountrySection(handle, group) {
    const section = document.createElement('section');
    section.id = `country-${handle}`;
    section.className = 'main-manufacturers__country-section';
    section.setAttribute('aria-labelledby', `country-heading-${handle}`);

    const heading = document.createElement('h2');
    heading.id = `country-heading-${handle}`;
    heading.className = 'main-manufacturers__country-heading h3';
    heading.textContent = group.name;
    section.appendChild(heading);

    const table = document.createElement('div');
    table.className = 'main-manufacturers__table';
    table.setAttribute('role', 'table');
    table.setAttribute(
      'aria-label',
      (this.dataset.i18nTableLabel || '').replace('%%COUNTRY%%', group.name)
    );

    const header = document.createElement('div');
    header.className = 'main-manufacturers__table-header';
    header.setAttribute('role', 'row');
    for (const label of [this.dataset.i18nProducer, this.dataset.i18nArea]) {
      const cell = document.createElement('div');
      cell.className = 'main-manufacturers__table-cell main-manufacturers__table-cell--header';
      cell.setAttribute('role', 'columnheader');
      cell.textContent = label || '';
      header.appendChild(cell);
    }
    table.appendChild(header);

    for (const row of group.rows) table.appendChild(row);
    section.appendChild(table);
    return section;
  }

  onNavClick(event) {
    const link = event.target.closest('.main-manufacturers__nav-button');
    if (!link || !this.contains(link)) return;

    const targetId = link.getAttribute('href');
    const target = targetId && this.querySelector(targetId);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.pushState(null, '', targetId);

    const heading = target.querySelector('.main-manufacturers__country-heading');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus();
    }
  }
}

if (!customElements.get('manufacturer-overview')) {
  customElements.define('manufacturer-overview', ManufacturerOverview);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palmares-carousel"] && !Shopify.designMode) return;
  try {
    
  // Center items when count is less than or equal to columns
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.palmares-carousel__wrapper');
    if (!wrapper) return;

    const itemCount = parseInt(getComputedStyle(wrapper).getPropertyValue('--palmares-item-count'));
    const columns = parseInt(getComputedStyle(wrapper).getPropertyValue('--palmares-columns'));

    if (itemCount <= columns) {
      wrapper.style.setProperty('--palmares-justify', 'center');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
